var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAbout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "23px",
    viewBox: "0 0 8 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic/about") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Version-12",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A03",
    transform: "translate(-416.000000, -545.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "screen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "settings-copy",
    transform: "translate(375.000000, 215.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tabs",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "about",
    transform: "translate(0.000000, 312.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.6372333,20.196025 C43.6925344,20.196025 42.9277036,19.3997877 42.9277036,18.4180125 C42.9277036,17.4362373 43.6925344,16.64 44.6372333,16.64 C45.5811502,16.64 46.3467629,17.4362373 46.3467629,18.4180125 C46.3467629,19.3997877 45.5811502,20.196025 44.6372333,20.196025 Z M47.3545135,35.8133371 C48.0628421,35.8133371 48.6367585,36.4103117 48.6367585,37.1466685 C48.6367585,37.8829237 48.0628421,38.48 47.3545135,38.48 L42.6450955,38.48 C41.9371579,38.48 41.3632415,37.8829237 41.3632415,37.1466685 C41.3632415,36.4103117 41.9371579,35.8133371 42.6450955,35.8133371 L43.718146,35.8133371 L43.718146,24.4363546 L42.6450955,24.4363546 C41.9371579,24.4363546 41.3632415,23.83938 41.3632415,23.1030231 C41.3632415,22.3666663 41.9371579,21.76959 42.6450955,21.76959 L45.000391,21.76959 C45.7083287,21.76959 46.282245,22.3666663 46.282245,23.1030231 L46.282245,35.8133371 L47.3545135,35.8133371 Z",
    id: "ic/about"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAbout);
export default __webpack_public_path__ + "static/media/icon_about.710496de84267a93d379a4de7a5f48b5.svg";
export { ForwardRef as ReactComponent };